import { differenceInMinutes, parseISO } from 'date-fns';

const calculateMinutesDuration = (ending: string, starting: string): number =>
  differenceInMinutes(parseISO(ending), parseISO(starting));

export default calculateMinutesDuration;
